// the root file, the parent of other file 

import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { App } from './App'

// conecting react to dom 
ReactDOM.render(<App />, document.getElementById('root'))
